import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { noop } from 'lodash';

import ButtonContent from 'components/questions/ButtonContent';
import ButtonContentView from 'components/questions/ButtonContentView';
import PageBreak from 'components/questions/PageBreak';
import { goToPreviousPage } from 'taker/actions/appActions';
import { goToPreviousPage as previewGoToPreviousPage } from 'actions/surveyPreviewActions';
import {
  getSurveyPreviewVisitedPagesLength,
  isSurveyBackButtonEnabled as isEditorBackButtonEnabled,
  isSurveyPreviewFirstPage,
} from 'reducers';
import {
  getVisitedPagesLength as getSurveyVisitedPagesLength,
  isSurveyBackButtonEnabled,
  isSurveyFirstPage,
} from 'taker/reducers';
import { mergeStylingWithBackButtonData } from '../../domains/styling/utils/mergeStylingWithBackButtonData';

const PageBreakTaker = ({
  block: { alignment, backButton = {} },
  block,
  canGoBack,
  onBack,
  pageNumber,
  styling,
  ...restProps
}) => (
  <PageBreak
    backButton={
      canGoBack
        ? PageBreakTaker.renderBackButton(
            backButton,
            styling,
            restProps,
            onBack,
          )
        : null
    }
    backButtonAlignment={backButton.alignment}
    nextButton={PageBreakTaker.renderNextButton(block, styling, restProps)}
    nextButtonAlignment={alignment}
    pageNumber={pageNumber}
  />
);

PageBreakTaker.propTypes = {
  styling: PropTypes.object,
  block: PropTypes.object.isRequired,
  canGoBack: PropTypes.bool,
  onBack: PropTypes.func,
  pageNumber: PropTypes.number,
};

PageBreakTaker.renderBackButton = (backButton, styling, props, onClick) => (
  <ButtonContentView
    {...props}
    styling={mergeStylingWithBackButtonData(styling, backButton)}
    block={backButton}
    e2e="taker-back-button"
    key="back-button"
    onClick={onClick}
  />
);

PageBreakTaker.renderNextButton = (block, styling, props) => (
  <ButtonContent
    {...props}
    styling={styling}
    block={block}
    e2e="taker-next-button"
    key="next-button"
  />
);

const mapStateToProps = (
  state,
  { isInAIOMode, isInPreviewMode, pageIndex },
) => {
  const isFirstPage = isInPreviewMode
    ? isSurveyPreviewFirstPage
    : isSurveyFirstPage;
  const getDisplayPage = isInPreviewMode
    ? getSurveyPreviewVisitedPagesLength
    : getSurveyVisitedPagesLength;
  const getBackButtonEnabled = isInPreviewMode
    ? isEditorBackButtonEnabled
    : isSurveyBackButtonEnabled;
  const isBackButtonEnabled = getBackButtonEnabled(state);
  const isCurrentPageFirst = isFirstPage(state);
  const isLatestVisitedPageAvailable = getDisplayPage(state) > 1;
  const isPreviousPageAvailable = isInAIOMode
    ? pageIndex > 0
    : !isCurrentPageFirst && isLatestVisitedPageAvailable;

  return {
    canGoBack: isBackButtonEnabled && isPreviousPageAvailable,
  };
};

const mapDispatchToProps = (dispatch, { isInAIOMode, isInPreviewMode }) => ({
  onBack: () =>
    isInAIOMode
      ? noop
      : dispatch(isInPreviewMode ? previewGoToPreviousPage : goToPreviousPage),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PageBreakTaker);
